import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import client from '../api/client'
import { useAuthStore } from '../store/authStore'
import { useCounselingStore } from '../store/counselingStore'
import DailyBanner from '../components/dashboard/DailyBanner'
import SajuCharacterCard from '../components/dashboard/SajuCharacterCard'
import DailyFortuneReceipt from '../components/dashboard/DailyFortuneReceipt'
import FeatureGrid from '../components/dashboard/FeatureGrid'
import RecentHistory from '../components/dashboard/RecentHistory'

export default function Dashboard() {
  const navigate = useNavigate()
  const { user, isAuthenticated, logout } = useAuthStore()
  const { sessions, setSessions } = useCounselingStore()

  const [saju, setSaju] = useState<any>(null)
  const [daily, setDaily] = useState<any>(null)
  const [lucky, setLucky] = useState<any>(null)
  const [luckyLoading, setLuckyLoading] = useState(false)

  useEffect(() => {
    if (!isAuthenticated) { navigate('/login'); return }
    client.get('/users/me/saju').then((r) => setSaju(r.data)).catch(() => {})
    client.get('/saju/daily').then((r) => setDaily(r.data)).catch(() => {})
    setLuckyLoading(true)
    client.get('/features/lucky-today').then((r) => setLucky(r.data)).catch(() => {}).finally(() => setLuckyLoading(false))
    client.get('/counseling/sessions').then((r) => setSessions(r.data)).catch(() => {})
  }, [isAuthenticated])

  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      {/* 헤더 — 편의점 간판 */}
      <header className="bg-[var(--color-primary)] sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <button onClick={() => navigate('/dashboard')}
            className="text-[var(--color-accent)] font-bold text-lg tracking-tight hover:opacity-80 transition-opacity">
            🏪 운명편의점
          </button>
          <div className="flex items-center gap-1">
            <button onClick={() => navigate('/profile')}
              className="flex items-center gap-1.5 text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] text-sm px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors">
              <span>👤</span>
              <span className="hidden sm:inline">{user?.nickname ?? '내 정보'}</span>
            </button>
            <button onClick={() => navigate('/counseling')}
              className="flex items-center gap-1.5 text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] text-sm px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors">
              <span>💬</span>
              <span className="hidden sm:inline">상담</span>
            </button>
            <button onClick={() => { logout(); navigate('/login') }}
              className="flex items-center gap-1.5 text-[var(--color-text-secondary)] hover:text-[var(--color-error)] text-sm px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors">
              <span className="hidden sm:inline">또 오세요 👋</span>
              <span className="sm:hidden">👋</span>
            </button>
          </div>
        </div>
      </header>

      {/* 본문 */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 space-y-6">

        {/* 인사 + 일진 배너 */}
        <DailyBanner
          nickname={user?.nickname ?? ''}
          dayPillar={daily ? `${daily.day_gan}${daily.day_ji}` : undefined}
          date={daily?.date}
        />

        {/* 내 사주 카드 + 오늘의 운세 (2단) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <SajuCharacterCard
            saju={saju}
            nickname={user?.nickname ?? ''}
            mbti={user?.mbti}
            bloodType={user?.blood_type}
          />
          <DailyFortuneReceipt lucky={lucky} loading={luckyLoading} />
        </div>

        {/* 기능 진열대 */}
        <FeatureGrid />

        {/* 최근 상담 내역 */}
        <RecentHistory sessions={sessions} />

      </main>
    </div>
  )
}
